import './App.css';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import HomeES from './es/es';
import HomeEN from './en/en';

function App() {
  return (
    <div className="App">
      <Router>
        <Routes>
          <Route path ="/" element={<Navigate to="/es" />}/>
          <Route path="/es" element={<HomeES></HomeES>}/>
          <Route path="/en" element={<HomeEN></HomeEN>}/>
        </Routes>
      </Router>
    </div>
  );
}

export default App;
